import { FC, ReactNode } from 'react';

import { Box, Modal, ModalProps, useTheme } from '@mui/material';

import { AppIcon } from '~components/shared/app-icon/app-icon';

import { ReactComponent as IconClose } from '~assets/icons/icon-close.svg';

type Props = {
  open: boolean;
  handleClose: () => void;
  children?: ReactNode;
} & Partial<ModalProps>;

export const ModalWrapper: FC<Props> = ({
  open,
  children,
  handleClose,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      // slotProps={{
      //   backdrop: {
      //     sx: {
      //       backgroundColor: OVERLAY_DARK,
      //       ...backdropSX,
      //     },
      //   },
      // }}
    >
      <Box
        className={'modal-wrapper'}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: '#fff',
          width: '100%',
          maxWidth: '50%',
          minWidth: {
            xs: 320,
            sm: 375,
          },
          // minWidth: 375,
          minHeight: 195,
          borderRadius: theme.spacing(1.5),
          overflowX: 'hidden',
          boxSizing: 'border-box',
          maxHeight: '80vh',

          '&:focus-visible': {
            outline: 'none',
          },
          // ...modalAnimation,
          // ...sx,
        }}
        {...rest}
      >
        <Box
          sx={{
            maxHeight: 'inherit',
            width: '100%',
            overflowY: 'auto',
            pb: 2,
            p: 3,
            boxSizing: 'border-box',
          }}
        >
          <Box
            role={'button'}
            sx={{
              position: 'absolute',
              top: 10,
              right: 10,
              padding: 0.5,
              cursor: 'pointer',
            }}
            onClick={handleClose}
          >
            <AppIcon component={IconClose} size={22} />
            {/*<SvgIcon*/}
            {/*  component={CloseIcon}*/}
            {/*  onClick={handleClose}*/}
            {/*  sx={{ cursor: 'pointer' }}*/}
            {/*  inheritViewBox*/}
            {/*/>*/}
          </Box>

          {children}
        </Box>
      </Box>
    </Modal>
  );
};
